export const BUSINESS_ERROR_CODE = {
  L0013: 'L0013',
  L0020: 'L0020',
  SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
  // アクセス集中エラー
  ACCESS_OVERLOAD: 'ACCESS_OVERLOAD',
} as const;

export type BusinessErrorCode = (typeof BUSINESS_ERROR_CODE)[keyof typeof BUSINESS_ERROR_CODE];
